import _ from 'lodash'
import Backbone from 'backbone'
import template from './datasets-equation-form.hbs'
import EquationEditor from 'scoreboard/components/equations/equation-editor'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import decimalSeparatorMessage from 'scoreboard/components/decimal-separator-message'

var DatasetsEquationForm = Backbone.View.extend({

	tagName: 'form',

	EquationEditor,

	/** @type EquationEditor */
	equationEditor: null,

	/**
	 * Base class for equation editors in datasets.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {String} options.equation the equation being edited
	 *
	 * @param {Boolean} [options.required=true] indicates whether entering an
	 * equation is required
	 */
	initialize: function(options) {
		this.options = options || {}
		this.equation = this.options.equation
	},

	className: 'datasets-equation-form equation-editor',

	events: {
		'change [name=connectionId]': 'renderColumnsDropdown'
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.createEquationEditor()
		// important: this goes after all the event handlers are setup
		this.equationEditor.render()

		this.renderBanner()

		return this
	},

	/**
	 * Display explanation in warning bannerif decimal separator for locale
	 * won't work with equation syntax (#36316)
	 */
	renderBanner: function() {
		if (config.decimalSeparator != '.') {
			this.$('.banner-warning').removeClass('is-not-displayed')
			this.$('.banner-warning').html(decimalSeparatorMessage())
		}
	},

	createEquationEditor: function() {
		this.equationEditor = new this.EquationEditor(this.equationEditorOptions())
		this.equationEditor.on('submit', this.submit.bind(this))
		this.equationEditor.on('edit', this.edit.bind(this))
		// #46054 override typeEquation instead of responding to an event so we can compare
		// equationEditor.previousEquation before it changes to the current equation
		this.equationEditor.typeEquation = this.typeEquation.bind(this)
		this.formView = this.equationEditor._formView
	},

	equationEditorOptions: function() {
		return {
			el: this.el,
			equation: this.equation,
			equationParser: this.equationParser,
			equationFormatter: this.createEquationFormatter(),
			// the equation can be blank, so you can submit right away
			allowCleanSubmission: true,
			required: this.options.required,
			test: this.test.bind(this)
		}
	},

	createEquationFormatter: function() {
		return new this.equationFormatter({ dataset: this.model })
	},

	context: function() {
		return {
			field: this.options.field,
			title: this.options.title
		}
	},

	// this is a non-static version of the function
	onInvalidEquation: function(xhr) {
		// call the static version
		DatasetsEquationForm.onInvalidEquation(xhr, this.equationEditor._formView)
	},


	typeEquation: function(e) {
		const previousEquationBlank = !_.isNil(this.equationEditor.previousEquation) &&
			this.equationEditor.previousEquation.length === 0
		const currentEquationBlank = this.equationEditor.getEquation().length === 0
		// #46054 if the user deletes the entire equation from the editor, clear everything
		if (!previousEquationBlank && currentEquationBlank) {
			this.aggregations = []
			this.equation = ''
		}

		EquationEditor.prototype.typeEquation.apply(this.equationEditor, arguments)
	},

	test: function() {
		if (this.hasInvalidFilters()) { // #45690 #50874
			return i18n.get('datasets.filters.invalid')
		}

		return this.equationEditor.test()
	},

	// if there are invalid filters, disable the Done button until the user fixes them
	hasInvalidFilters: function() {
		if (_.isNil(this.filterBadges)) return false

		return _.some(this.filterBadges.filters, filter => !filter.valid)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.equationEditor], 'remove')
	}

}, {
	onInvalidEquation: function(xhr, formView) {
		formView.error(xhr)
		if (xhr.responseJSON.evaluatorMessage) {
			formView.$('.banner-error').html(
				'<div>' + _.escape(xhr.responseJSON.message) + '</div>' +
				'<div class="paragraph">' + _.escape(i18n.get(xhr.responseJSON.evaluatorMessage)) + '</div>')
		}
	}
})

export default DatasetsEquationForm

DatasetsEquationForm.__filename__ = 'datasets/equations/datasets-equation-form.js'
